import React, { useState, useEffect } from "react"
import {
  Modal, Select, DatePicker, Button, InputNumber,
} from "antd"
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons"
import moment from "moment"
import PropTypes from "prop-types"
import _ from "underscore"
import commonStrings from "../../commonStrings"
import { disabledDate } from "../../utilities"

const SetIndicatorGoalModal = ({
  isVisible,
  onClose,
  indicatorData,
  tableData,
  upsertGoals,
  onSaveGoal,
  setSavingdIndicator,
  setSavingdTarget,
  tableListing,
  tableListingold,
  indicatorNumber = null,
  disabled = false,
  indicatorDetails = {},
  isEditMode = false,
}) => {
  const [formErrors, setFormErrors] = useState({})
  const [indicators, setIndicators] = useState([
    {
      implementation_rubric_indicator_id: "",
      indicatorLabel: "",
      targetValue: "",
      targetDate: null,
    },
  ])

  const handleAddIndicator = () => {
    setIndicators([
      ...indicators,
      {
        id: indicators.length + 1,
        implementation_rubric_indicator_id: "",
        indicatorLabel: "",
        targetValue: "",
        targetDate: null,
      },
    ])
  }

  useEffect(() => {
    if (indicatorData) {
      setIndicators([
        {
          implementation_rubric_indicator_id:
            indicatorData.implementation_rubric_indicator_id || "",
          targetValue:
            indicatorData.value === 0 ? 0 : indicatorData.value || "",
          targetDate: indicatorData.target_completion_date
            ? moment(indicatorData.target_completion_date)
            : null,
        },
      ])
    } else {
      setIndicators([
        {
          implementation_rubric_indicator_id: "",
          indicatorLabel: "",
          targetValue: "",
          targetDate: null,
        },
      ])
    }
  }, [indicatorData, tableData])

  const handleRemoveIndicator = (id) => {
    setIndicators((prev) => prev.filter((item) => item.id !== id))
  }

  const handleInputChange = (id, field, value) => {
    setIndicators((prev) => prev.map((item) => (item.id === id ? { ...item, [field]: value } : item)))

    if (formErrors[id] && formErrors[id][field]) {
      setFormErrors((prev) => {
        const newErrors = { ...prev }
        if (newErrors[id]) {
          delete newErrors[id][field]
          if (Object.keys(newErrors[id]).length === 0) {
            delete newErrors[id]
          }
        }
        return newErrors
      })
    }
  }

  const validateFields = () => {
    const newErrors = {}
    let isValid = true

    indicators.forEach((item) => {
      const val = Number(item.targetValue)
      const date = item.targetDate
      if (!indicatorNumber && !item.implementation_rubric_indicator_id) {
        newErrors[item.id] = {
          ...newErrors[item.id],
          indicator: "Indicator is required",
        }
        isValid = false
      }

      if (item.targetValue === "" || Number.isNaN(val)) {
        newErrors[item.id] = {
          ...newErrors[item.id],
          targetValue: "Target value is required",
        }
        isValid = false
      } else if (val < 0 || val > 4) {
        newErrors[item.id] = {
          ...newErrors[item.id],
          targetValue: "Target value must be between 0 and 4",
        }
        isValid = false
      }

      if (!date) {
        newErrors[item.id] = {
          ...newErrors[item.id],
          targetDate: "Target date is required",
        }
        isValid = false
      }
    })

    setFormErrors(newErrors)
    return isValid
  }

  const handleSaveGoal = () => {
    if (!validateFields()) {
      return
    }

    const goals = indicators.map((item) => ({
      implementation_rubric_indicator_id:
        item.implementation_rubric_indicator_id,
      value: Number(item.targetValue),
      target_completion_date: item.targetDate
        ? moment(item.targetDate).format("YYYY-MM-DD")
        : null,
    }))
    upsertGoals(goals)
    onSaveGoal(goals)
    onClose()
  }
  const validTableListing = Array.isArray(tableListing) && tableListing.length > 0
    ? tableListing
    : (tableListingold && tableListingold.data) || []

  const indicatorsWithGoals = validTableListing
    .filter((item) => item.goal !== null && item.indicator_id !== undefined)
    .map((item) => item.indicator_id.toString())

  // const indicatorsWithGoals = (
  //   tableListing && tableListing.data ? tableListing.data : []
  // )
  //   .filter((item) => item.goal !== null && item.indicator_id !== undefined)
  //   .map((item) => item.indicator_id.toString());

  const getFilteredOptionsForRow = (currentId) => tableData.filter((option) => {
    const isCurrentIndicator = indicatorData
        && indicatorData.implementation_rubric_indicator_id !== undefined
      ? indicatorData.implementation_rubric_indicator_id.toString()
            === option.value.toString()
      : false

    const currentFormSelections = indicators
      .filter((ind) => ind.id !== currentId)
      .map((ind) => (ind.implementation_rubric_indicator_id !== null
          && ind.implementation_rubric_indicator_id !== undefined
        ? ind.implementation_rubric_indicator_id.toString()
        : null))
      .filter(Boolean)

    return (
      (!indicatorsWithGoals.includes(option.value.toString())
          || isCurrentIndicator)
        && !currentFormSelections.includes(option.value.toString())
    )
  })

  return (
    <Modal
      title={disabled ? "View Indicator Goal" : "Set Indicator Goal(s)"}
      open={isVisible}
      onCancel={onClose}
      footer={null}
      width={580}
      style={{ borderRadius: "10px", padding: "10px" }}
      className="IndicatorgoalModal"
    >
      {indicators.map((item, index) => {
        const rowFilteredOptions = getFilteredOptionsForRow(
          item.id,
          item.implementation_rubric_indicator_id,
        )

        return (
          <div key={item.id} style={{ marginBottom: "15px" }}>
            {indicatorNumber ? (
              <div>
                <span
                  style={{
                    fontWeight: "bold",
                    marginBottom: 5,
                  }}
                >
                  Selected Indicator
                </span>
                : <span>{indicatorNumber}</span>
              </div>
            ) : (
              <>
                <label
                  style={{
                    fontWeight: "bold",
                    display: "block",
                    marginBottom: 5,
                  }}
                >
                  {commonStrings.indicator}*
                </label>
                <Select
                  style={{ width: "100%" }}
                  value={
                    item.implementation_rubric_indicator_id
                      ? item.implementation_rubric_indicator_id
                      : null
                  }
                  onChange={(value) => {
                    const selectedOption = rowFilteredOptions.find(
                      (option) => option.value.toString() === value.toString(),
                    )
                    handleInputChange(
                      item.id,
                      "implementation_rubric_indicator_id",
                      value,
                    )
                    handleInputChange(
                      item.id,
                      "indicatorLabel",
                      selectedOption && selectedOption.label
                        ? selectedOption.label
                        : "",
                    )

                    setSavingdIndicator(value)
                  }}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                  status={
                    formErrors[item.id] && formErrors[item.id].indicator
                      ? "error"
                      : ""
                  }
                  placeholder="Select Indicator"
                  disabled={isEditMode || disabled}
                >
                  {rowFilteredOptions.map((option) => (
                    <Select.Option
                      key={option.value}
                      value={option.value}
                      disabled={option.disabled}
                    >
                      {option.label}
                    </Select.Option>
                  ))}
                </Select>

                {formErrors[item.id] && formErrors[item.id].indicator && (
                  <div style={{ color: "#a6192e", marginTop: 4 }}>
                    {formErrors[item.id].indicator}
                  </div>
                )}
              </>
            )}
            {_.isEmpty(indicatorDetails) ? (
              <div style={{ display: "flex", gap: "10px", marginTop: "15px" }}>
                <div style={{ flex: 1 }}>
                  <label
                    style={{
                      fontWeight: "bold",
                      display: "block",
                      marginBottom: 5,
                    }}
                  >
                    {commonStrings.targetValueTitle} *
                  </label>
                  <InputNumber
                    disabled={disabled}
                    min={0}
                    max={4}
                    style={{ width: "100%" }}
                    value={item.targetValue}
                    onChange={(value) => {
                      handleInputChange(item.id, "targetValue", value)
                      setSavingdTarget(value)
                    }}
                    parser={(value) => Math.round(value)}
                    formatter={(value) => (value ? Math.round(value) : "")}
                    status={
                      formErrors[item.id] && formErrors[item.id].targetValue
                        ? "error"
                        : ""
                    }
                    placeholder="Target Value"
                  />
                  {formErrors[item.id] && formErrors[item.id].targetValue && (
                    <div style={{ color: "#a6192e", marginTop: 4 }}>
                      {formErrors[item.id].targetValue}
                    </div>
                  )}
                  <div
                    style={{
                      fontStyle: "italic",
                      marginTop: 5,
                      fontSize: 10,
                      fontWeight: 600,
                    }}
                  >
                    {commonStrings.targetValueNumber}
                  </div>
                </div>

                <div style={{ flex: 1 }}>
                  <label
                    style={{
                      fontWeight: "bold",
                      display: "block",
                      marginBottom: 5,
                    }}
                  >
                    {commonStrings.targetCompletionDate} *
                  </label>
                  <DatePicker
                    disabled={disabled}
                    style={{ width: "100%" }}
                    placeholder="mm/dd/yyyy"
                    value={item.targetDate}
                    onChange={(date) => handleInputChange(
                      item.id,
                      "targetDate",
                      date ? moment(date) : null,
                    )}
                    disabledDate={disabledDate}
                    status={
                      formErrors[item.id] && formErrors[item.id].targetDate
                        ? "error"
                        : ""
                    }
                  />
                  {formErrors[item.id] && formErrors[item.id].targetDate && (
                    <div style={{ color: "#a6192e", marginTop: 4 }}>
                      {formErrors[item.id].targetDate}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div>
                <div>
                  <span
                    style={{
                      fontWeight: "bold",
                      marginBottom: 5,
                    }}
                  >
                    Target Value
                  </span>
                  : <span>{indicatorDetails.value}</span>
                </div>
                <div>
                  <span
                    style={{
                      fontWeight: "bold",
                      marginBottom: 5,
                    }}
                  >
                    Target Date
                  </span>
                  : <span>{indicatorDetails.target_completion_date}</span>
                </div>
              </div>
            )}

            {indicators.length > 1 && index > 0 && (
              <div
                style={{
                  color: "#a6192e",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  marginTop: "10px",
                  justifyContent: "flex-end",
                }}
                onClick={() => handleRemoveIndicator(item.id)}
              >
                <MinusCircleOutlined style={{ marginRight: 5 }} />
                Remove
              </div>
            )}
          </div>
        )
      })}

      {!indicatorData && !indicatorNumber && !disabled && (
        <div
          style={{
            marginTop: "15px",
            color: "#555",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
          }}
          onClick={handleAddIndicator}
        >
          <PlusOutlined style={{ marginRight: 5 }} />
          {commonStrings.addAnotherIndicator}
        </div>
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "20px",
          gap: "10px",
        }}
      >
        <Button
          style={{
            background: "#D3D3D3",
            borderColor: "#D3D3D3",
            color: "#000",
          }}
          onClick={onClose}
        >
          {!disabled ? commonStrings.cancel : "Close"}{" "}
        </Button>
        {!disabled && (
          <Button
            type="primary"
            style={{
              background: "#8B0000",
              borderColor: "#8B0000",
              color: "#fff",
            }}
            onClick={handleSaveGoal}
          >
            {commonStrings.saveGoal}
          </Button>
        )}
      </div>
    </Modal>
  )
}

SetIndicatorGoalModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  indicatorData: PropTypes.shape({
    implementation_rubric_indicator_id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    target_completion_date: PropTypes.string,
  }),
  tableData: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  upsertGoals: PropTypes.func.isRequired,
  onSaveGoal: PropTypes.func.isRequired,
  setSavingdIndicator: PropTypes.func,
  setSavingdTarget: PropTypes.func,
  // tableListing: PropTypes.object,
  tableListing: PropTypes.shape({
    data: PropTypes.arrayOf(
      PropTypes.shape({
        goal: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
        indicator_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
    ),
  }),
  tableListingOld: PropTypes.shape({
    data: PropTypes.arrayOf(
      PropTypes.shape({
        goal: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
        indicator_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
    ),
  }),
  indicatorNumber: PropTypes.string,
  disabled: PropTypes.bool,
  // indicatorDetails: PropTypes.object,
  indicatorDetails: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    target_completion_date: PropTypes.string,
  }),
  isEditMode: PropTypes.bool,
}

SetIndicatorGoalModal.defaultProps = {
  indicatorData: null,
  setSavingdIndicator: () => {},
  setSavingdTarget: () => {},
  tableListing: null,
  tableListingOld: null,
  indicatorNumber: null,
  disabled: false,
  indicatorDetails: {},
  isEditMode: false,
}

export default SetIndicatorGoalModal
